import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import styles from "./index.module.css"

const ClientProfileLayout = () => {
  return (
    <Layout className={styles.layout}>
      <Outlet />
    </Layout>
  )
}

export default ClientProfileLayout
